import React from "react";

interface Reset2FACellValue {
  memberId?: string;
  onReset?: () => void;
  disabled?: boolean;
}

interface Reset2FACellProps {
  value?: Reset2FACellValue;
  [key: string]: any;
}

/**
 * Action cell rendering a "Reset 2FA" link button.
 *
 * Self-contained: clicking fires the row's `value.onReset()` callback (mirrors
 * `EditIconCell`). Stops event propagation so the table's row-level click
 * handler does not also fire.
 */
export const Reset2FACell: React.FC<Reset2FACellProps> = ({ value }) => {
  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    if (value?.disabled) {
      return;
    }
    value?.onReset?.();
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
      }}
    >
      <button
        type="button"
        onClick={handleClick}
        disabled={value?.disabled}
        style={{
          background: "none",
          border: "none",
          padding: 0,
          color: value?.disabled ? "#9ca3af" : "#2563eb",
          cursor: value?.disabled ? "not-allowed" : "pointer",
          fontSize: "inherit",
          textDecoration: "underline",
          whiteSpace: "nowrap",
        }}
      >
        Reset 2FA
      </button>
    </div>
  );
};

export default Reset2FACell;
